<template>
<div class="section login-view">
    <div class="row w-100 justify-content-center">
      <div class="col-12 col-md-5 card text-left mt-5">
         <div class="card-body">
          <h5 class="card-title">Recuperar contraseña</h5>
          <div v-if="error" class="alert alert-danger" role="alert">
            <strong>¡Error!</strong> <br > Las contraseñas deben ser idénticas. <br> La contraseña debe tener al menos 6 carácteres.
          </div>
          <form v-on:submit="submit" method="post">
            <div class="form-group">
              <label for="input-password">Contraseña</label>
              <input type="password" v-model="password" class="form-control" id="input-password" aria-describedby="password-help" placeholder="Contraseña">
              <small id="password-help" class="form-text text-muted">Ingresa una nueva contraseña.</small>
            </div>
            <div class="form-group">
              <label for="input-repassword2">Repetir contraseña</label>
              <input type="password" v-model="password2" class="form-control" id="input-email" aria-describedby="password2-help" placeholder="Repetir contraseña">
              <small id="password2-help" class="form-text text-muted">Ingresa la contraseña anterior.</small>
            </div>
            <div class="form-group d-flex justify-content-end">
              <button class="btn btn-primary" type="submit">Enviar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recoverPasswordNew',
  created() {
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    submit: function(event) {
      let self = this;
      event.preventDefault();
      const { token } = this.$route.query;
      const { url } = this.$store.state.connection;
      const payload = {
        params: {
          new_password: this.password,
          new_password2: this.password2,
        },
      };
      this.$http.post(`${url}reset/${token}`, payload)
      .then((result) => {
        self.$router.replace('login');
      })
      .catch((err) => {
        self.error = err;
        console.error(err);
      });
    }
  },
  components: {
  },
  data: function() {return {
    password: '',
    password2: '',
    error: '',
  }},
}
</script>

<style scoped>
  .login-view{
    display: flex;
    background-color: rgba(211, 99, 0, 0.7);
    background-image: url('../assets/background.jpg');
    box-shadow: inset 0 0 0 1000px rgba(211,99,0,.7);
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 100vh;
  }
  section{
    color: #ffffff !important;
  }
  .login-view .btn-link{
  color: #fff !important;
  font-size: 14px !important;
  }
 .login-view .btn, .login-view form,  .login-view .card{
  color: #fff !important;
  font-size: 14px !important;
  }
  .login-view .text-muted{
  color: #fff !important;
  }
  .login-view .btn-primary{
  background-color: transparent !important;
  border-color: #fff;
  }
    input{
  background-color: rgba(255, 255, 255, 0.25) !important;
  color: #fff !important;
  font-size: 16px;
  padding: 20px;
}
.input-group-text{
  background-color: rgba(255, 255, 255, 0.25) !important;
}
::-webkit-input-placeholder { /* Chrome */
  color: #fff !important;
  opacity: 1 !important;
  font-size: 16px;
}
::placeholder { /* Chrome */
  color: #fff !important;
  opacity: 1 !important;
  font-size: 16px;
}
</style>
